import { useTranslator } from '@bluebeam/react-i18n';
import { useAuth } from 'auth';
import SingleFilter from 'components/FilterPopover/SingleFilter';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { RFIQuery } from 'records/RFIQuery';
import { User } from 'records/User';

interface Props {
  rfiTableQuery: RFIQuery;
  updateRFIQuery: (nextRFIQuery: RFIQuery) => void;
}

const AssignedToMeCheckbox: React.FC<Props> = (props: Props) => {
  const { rfiTableQuery, updateRFIQuery } = props;
  const { state: appState } = useContext(AppStoreContext);
  const { translate } = useTranslator(['filters']);
  const { userId } = useAuth();

  const currentUser = appState.users.find(
    (u) => userId === u.id,
    {},
    new User()
  ) as User;

  /* Handlers */
  function onCheckboxChange(isChecked: boolean) {
    const nextRFIQuery = rfiTableQuery.update('assignees', (a) => {
      return isChecked
        ? a.add(currentUser)
        : a.filter((u) => u.id !== currentUser.id);
    });

    updateRFIQuery(nextRFIQuery);
  }

  const rfisAssignedToUser = appState.rfis
    .valueSeq()
    .flatMap((rfi) => rfi.assignees)
    .some((a) => a.id === currentUser.id);

  const assigneeIsCurrentUser = rfiTableQuery.assignees.some(
    (a) => a.id === currentUser.id
  );

  return (
    <SingleFilter
      checked={assigneeIsCurrentUser}
      text={translate('filters:assignedToMe')}
      onChange={onCheckboxChange}
      disabled={!rfisAssignedToUser}
    />
  );
};

export default AssignedToMeCheckbox;
